import { Toggle } from './Toggle'

const Types = {
    'toggle': Toggle
}

export default Types;